import React from "react";

function Footer() {
  return (
    <div className="bg-darkmode text-gray-500 flex justify-center pt-10 pb-5 text-sm">
      <p>Made with ❤️ by Darshan</p>
    </div>
  );
}

export default Footer;
